export class Motorista {
    ativo: boolean;
    id: number;
    cnh: string;
    dataAdmissao: string;
    dataDemissao: string;
    lentesObrigatorias: boolean;
    observacoes: string;
    possuiCategoriaA: boolean;
    possuiCategoriaB: boolean;
    possuiCategoriaC: boolean;
    possuiCategoriaD: boolean;
    possuiCategoriaE: boolean;
    primeiraHabilitacao: string;
    validadeHabilitacao: string;
    vinculoEmpregaticio: boolean;
    funcionarioId: number;
    categoriaCnhId: number;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/motoristas/shared/motorista.model.ts
 **/